// ROUTES
require('modules/check/routes/check');

// CONTROLLERS
require('modules/check/controllers/check');
require('modules/check/controllers/check-invitation');

// SERVICES
require('modules/check/services/check');
require('modules/check/services/check-invitation');


angular.module('unica_check', [

	// ROUTES
	'unica_check.check_routes',

	// CONTROLLERS
	'unica_check.check_controllers',

	// SERVICES
	'unica_check.check_services'

]);
